(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["club"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var form = document.querySelector('[data-club-form]');
    if (!form || form.dataset.bound === 'true') return;
    form.dataset.bound = 'true';

    var card = form.closest('[data-club-card]');
    var intro = card.querySelector('[data-club-intro]');
    var done = card.querySelector('[data-club-done]');
    var error = form.querySelector('[data-club-error]');
    var button = form.querySelector('[data-club-submit]');
    var label = form.querySelector('[data-club-submit-label]');
    var labelText = label ? label.textContent : 'Join the waitlist';

    function showError(message) {
      error.hidden = false;
      error.textContent = message;
    }

    function klaviyo(key, path, body) {
      return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(key), {
        method: 'POST',
        keepalive: true,
        headers: {
          'content-type': 'application/vnd.api+json',
          accept: 'application/vnd.api+json',
          revision: '2024-10-15'
        },
        body: JSON.stringify(body)
      }).then(function (response) {
        if (!response.ok) throw new Error('Klaviyo ' + response.status);
        return true;
      });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      error.hidden = true;

      var key = (form.dataset.klaviyoKey || '').trim();
      var listId = (form.dataset.klaviyoList || '').trim();
      var firstName = form.first_name.value.trim().replace(/\s+/g, ' ');
      var email = form.email.value.trim();

      if (!key || !listId) {
        showError('The waitlist isn’t connected yet. Please try again soon.');
        return;
      }

      button.disabled = true;
      if (label) label.textContent = 'Joining…';

      var profileEvent = klaviyo(key, 'events', {
        data: {
          type: 'event',
          attributes: {
            properties: { source: 'The Club page' },
            unique_id: email.toLowerCase() + ':club:' + Date.now(),
            metric: { data: { type: 'metric', attributes: { name: 'Joined Club Waitlist' } } },
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  first_name: firstName,
                  properties: { club_waitlist: true }
                }
              }
            }
          }
        }
      }).catch(function () {
        return false;
      });

      profileEvent.then(function () {
        return klaviyo(key, 'subscriptions', {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'INNERDAY Club',
              profile: {
                data: {
                  type: 'profile',
                  attributes: { email: email }
                }
              }
            },
            relationships: { list: { data: { type: 'list', id: listId } } }
          }
        });
      }).then(function () {
        intro.hidden = true;
        done.hidden = false;
        var heading = done.querySelector('h2');
        if (heading) heading.focus();
      }).catch(function () {
        button.disabled = false;
        if (label) label.textContent = labelText;
        showError('Something went wrong. Please try again.');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  if (!window.__innerdayCatalog) {
    window.__innerdayCatalog = true;

    const bindCatalog = (root) => {
      if (!root || root.dataset.ready === 'true') return;
      const grid = root.querySelector('[data-lineup-grid]');
      const dots = [...root.querySelectorAll('[data-lineup-dot]')];
      if (!grid || dots.length < 2) return;
      root.dataset.ready = 'true';
      const items = [...grid.children];

      const update = () => {
        const left = grid.getBoundingClientRect().left;
        let active = 0;
        let best = Infinity;
        items.forEach((item, index) => {
          const distance = Math.abs(item.getBoundingClientRect().left - left);
          if (distance < best) {
            best = distance;
            active = index;
          }
        });
        dots.forEach((dot, index) => {
          if (index === active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      };

      grid.addEventListener('scroll', update, { passive: true });
      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          items[index]?.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        });
      });
    };

    document.querySelectorAll('[data-lineup]').forEach(bindCatalog);
    document.addEventListener('shopify:section:load', (event) => {
      bindCatalog(event.target.querySelector('[data-lineup]'));
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["experts"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-experts]').forEach((root) => {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    root.querySelectorAll('[data-expert]').forEach((item) => {
      const dialog = item.querySelector('dialog');
      const open = item.querySelector('[data-expert-open]');
      const close = item.querySelector('[data-expert-close]');
      if (!dialog || !open) return;

      open.addEventListener('click', () => dialog.showModal());
      close?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  class FaqList extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';

      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.items = [...this.querySelectorAll('.faq-item')];

      this.items.forEach((item) => {
        const panel = item.querySelector('.faq-item__panel');
        panel.style.height = item.open ? 'auto' : '0px';

        item.querySelector('summary').addEventListener('click', (event) => {
          event.preventDefault();
          if (item.open) {
            this.close(item);
            return;
          }
          this.items.forEach((other) => {
            if (other !== item && other.open) this.close(other);
          });
          this.open(item);
        });
      });
    }

    open(item) {
      const panel = item.querySelector('.faq-item__panel');
      item.open = true;
      if (this.reduceMotion) {
        panel.style.height = 'auto';
        return;
      }
      panel.style.height = '0px';
      const target = panel.scrollHeight;
      panel.offsetHeight;
      panel.style.height = `${target}px`;
      this.afterHeight(panel, () => {
        if (item.open) panel.style.height = 'auto';
      });
    }

    close(item) {
      const panel = item.querySelector('.faq-item__panel');
      if (this.reduceMotion) {
        panel.style.height = '0px';
        item.open = false;
        return;
      }
      panel.style.height = `${panel.scrollHeight}px`;
      panel.offsetHeight;
      panel.style.height = '0px';
      this.afterHeight(panel, () => {
        item.open = false;
      });
    }

    afterHeight(panel, callback) {
      const onEnd = (event) => {
        if (event.target !== panel || event.propertyName !== 'height') return;
        panel.removeEventListener('transitionend', onEnd);
        callback();
      };
      panel.addEventListener('transitionend', onEnd);
    }
  }

  if (!customElements.get('faq-list')) {
    customElements.define('faq-list', FaqList);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gut-guide"] && !Shopify.designMode) return;
  try {
    
  function bindGuide(root) {
    if (!root || root.dataset.guideBound === 'true') return;
    root.dataset.guideBound = 'true';
    var hoverFine = window.matchMedia('(hover: hover)');
    root.querySelectorAll('[data-guide-card]').forEach(function (card) {
      var button = card.querySelector('[data-guide-note]');
      if (!button) return;
      button.addEventListener('click', function () {
        if (hoverFine.matches) return;
        var open = card.classList.toggle('is-open');
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    var grid = root.querySelector('[data-guide-grid]');
    var dots = [...root.querySelectorAll('[data-guide-dot]')];
    if (!grid || dots.length < 2) return;
    var items = [...grid.children];
    var narrow = window.matchMedia('(max-width: 749px)');
    var update = function () {
      if (!narrow.matches) return;
      var left = grid.getBoundingClientRect().left;
      var index = 0;
      var best = Infinity;
      items.forEach(function (item, i) {
        var distance = Math.abs(item.getBoundingClientRect().left - left);
        if (distance < best) {
          best = distance;
          index = i;
        }
      });
      dots.forEach(function (dot, i) {
        if (i === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    };
    grid.addEventListener('scroll', update, { passive: true });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        grid.scrollTo({ left: items[i].offsetLeft, behavior: 'smooth' });
      });
    });
  }

  bindGuide(document.querySelector('.guide'));
  document.addEventListener('shopify:section:load', function (event) {
    bindGuide(event.target.querySelector('.guide'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const announce = document.querySelector('.home-announce');
  if (announce) {
    const setAnnounce = () => {
      document.documentElement.style.setProperty('--home-announce', announce.offsetHeight + 'px');
    };
    setAnnounce();
    window.addEventListener('resize', setAnnounce);
  }

  const headerGroup = document.querySelector('.header')?.closest('.shopify-section-group-header-group');

  if (headerGroup && document.querySelector('.hero, .pdp-hero')) {
    let frame = 0;

    const update = () => {
      const y = window.scrollY;
      const fade = Math.min(Math.max(y / 110, 0), 1);

      headerGroup.style.setProperty('--header-fade', fade.toFixed(3));
      headerGroup.classList.toggle('is-solid', y > 56);
      headerGroup.classList.remove('is-hidden');
      frame = 0;
    };

    update();
    headerGroup.querySelector('.header__details')?.addEventListener('toggle', update);
    window.addEventListener(
      'scroll',
      () => {
        if (frame) return;
        frame = requestAnimationFrame(update);
      },
      { passive: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hero-slider')) {
  class HeroSlider extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-hero-viewport]');
      this.dots = [...this.querySelectorAll('[data-hero-dot]')];
      if (!this.viewport || this.dots.length < 2) return;

      this.querySelector('[data-hero-prev]')?.addEventListener('click', () => this.go(-1));
      this.querySelector('[data-hero-next]')?.addEventListener('click', () => this.go(1));
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.goTo(index));
      });
      this.viewport.addEventListener('scroll', () => this.sync(), { passive: true });
      this.viewport.addEventListener(
        'wheel',
        (event) => {
          if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) return;
          event.preventDefault();
          window.scrollBy(0, event.deltaY);
        },
        { passive: false }
      );
    }

    go(direction) {
      const index = this.current() + direction;
      this.goTo(Math.min(Math.max(index, 0), this.viewport.children.length - 1));
    }

    goTo(index) {
      this.viewport.scrollTo({
        left: index * this.viewport.clientWidth,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      });
    }

    current() {
      const width = this.viewport.clientWidth || 1;
      return Math.round(this.viewport.scrollLeft / width);
    }

    sync() {
      const index = this.current();
      this.dots.forEach((dot, i) => {
        if (i === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }
  }

  customElements.define('hero-slider', HeroSlider);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-lineup"] && !Shopify.designMode) return;
  try {
    
  if (!window.__innerdayLineup) {
    window.__innerdayLineup = true;

    const bindLineup = (root) => {
      if (!root || root.dataset.ready === 'true') return;
      const grid = root.querySelector('[data-lineup-grid]');
      const dots = [...root.querySelectorAll('[data-lineup-dot]')];
      if (!grid || dots.length < 2) return;
      root.dataset.ready = 'true';
      const items = [...grid.children];

      const update = () => {
        const left = grid.getBoundingClientRect().left;
        let active = 0;
        let best = Infinity;
        items.forEach((item, index) => {
          const distance = Math.abs(item.getBoundingClientRect().left - left);
          if (distance < best) {
            best = distance;
            active = index;
          }
        });
        dots.forEach((dot, index) => {
          if (index === active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      };

      grid.addEventListener('scroll', update, { passive: true });
      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          items[index]?.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        });
      });
    };

    document.querySelectorAll('[data-lineup]').forEach(bindLineup);
    document.addEventListener('shopify:section:load', (event) => {
      bindLineup(event.target.querySelector('[data-lineup]'));
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pdp-hero')) {
    class PdpHero extends HTMLElement {
      connectedCallback() {
        this.quotes = [...this.querySelectorAll('[data-quote]')];
        this.dots = [...this.querySelectorAll('[data-dot]')];
        this.index = 0;
        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => this.go(Number(dot.dataset.dot)));
        });
        if (this.quotes.length < 2) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.timer = window.setInterval(() => {
          this.go((this.index + 1) % this.quotes.length);
        }, 5200);
      }

      disconnectedCallback() {
        window.clearInterval(this.timer);
      }

      go(index) {
        this.index = index;
        this.quotes.forEach((quote, i) => quote.classList.toggle('is-active', i === index));
        this.dots.forEach((dot, i) => {
          if (i === index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }
    }

    customElements.define('pdp-hero', PdpHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-router"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-lymph-router]').forEach(function (root) {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    function show(zone) {
      root.setAttribute('data-zone', zone);
      root.querySelectorAll('[data-zone-btn]').forEach(function (button) {
        var on = button.getAttribute('data-zone-btn') === zone;
        button.classList.toggle('is-active', on);
        if (button.classList.contains('lymph-router__zone')) {
          button.setAttribute('aria-pressed', on ? 'true' : 'false');
        }
      });
      root.querySelectorAll('[data-zone-image]').forEach(function (image) {
        var on = image.getAttribute('data-zone-image') === zone;
        image.classList.toggle('is-active', on);
      });
      root.querySelectorAll('[data-zone-panel]').forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-zone-panel') !== zone;
      });
    }

    root.addEventListener('click', function (event) {
      var button = event.target.closest('[data-zone-btn]');
      if (!button || !root.contains(button)) return;
      show(button.getAttribute('data-zone-btn'));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-system"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var mobileQuery = window.matchMedia('(max-width: 768px)');

    document.querySelectorAll('[data-lymph-system]').forEach(function (section) {
      var visual = section.querySelector('[data-lymph-fill]');
      if (!visual || visual.dataset.ready === 'true') return;
      visual.dataset.ready = 'true';

      var capsule = visual.querySelector('.lymph-system__capsule');
      var pills = Array.prototype.slice.call(visual.querySelectorAll('[data-pill-pair]'));
      var images = Array.prototype.slice.call(visual.querySelectorAll('[data-step-image]'));
      var reds = pills.filter(function (pill) { return pill.classList.contains('lymph-system__pill--bad'); });
      var centres = [];
      var current = -1;

      function measure() {
        var box = capsule.getBoundingClientRect();
        centres = reds.map(function (pill) {
          var rect = pill.getBoundingClientRect();
          return {
            pair: pill.getAttribute('data-pill-pair'),
            at: box.height ? (rect.top + rect.height / 2 - box.top) / box.height : 1
          };
        }).sort(function (a, b) { return a.at - b.at; });
      }

      function show(count) {
        if (count === current) return;
        current = count;
        var cleared = {};
        centres.forEach(function (centre, index) {
          if (index < count) cleared[centre.pair] = true;
        });
        pills.forEach(function (pill) {
          pill.classList.toggle('is-cleared', !!cleared[pill.getAttribute('data-pill-pair')]);
        });
        var step = Math.min(count, Math.max(0, images.length - 1));
        images.forEach(function (image, index) {
          image.classList.toggle('is-on', index <= step);
        });
      }

      if (reduced) {
        visual.style.setProperty('--fill', '1');
        images.forEach(function (image) { image.classList.add('is-on'); });
        pills.forEach(function (pill) { pill.classList.add('is-cleared'); });
        return;
      }

      visual.classList.add('is-instant');
      measure();
      show(0);
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () { visual.classList.remove('is-instant'); });
      });

      function apply() {
        var box = visual.getBoundingClientRect();
        var view = window.innerHeight;
        var height = visual.offsetHeight;
        var progress;
        if (mobileQuery.matches) {
          var mobileStart = view * 0.55;
          var mobileEnd = view * 0.5 - height;
          progress = (mobileStart - box.top) / Math.max(240, mobileStart - mobileEnd);
        } else {
          var start = view * 0.3;
          var end = view * 0.6 - height;
          progress = (start - box.top) / Math.max(240, start - end);
        }
        progress = Math.round(Math.min(1, Math.max(0, progress)) * 1000) / 1000;
        visual.style.setProperty('--fill', progress);
        show((function () {
          var count = 0;
          centres.forEach(function (centre) { if (progress >= centre.at) count += 1; });
          return count;
        })());
      }

      apply();
      window.addEventListener('scroll', apply, { passive: true });
      window.addEventListener('resize', function () { measure(); apply(); });
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () { measure(); apply(); });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-urgency"] && !Shopify.designMode) return;
  try {
    
  if (!window.__innerdayUrgency) {
    window.__innerdayUrgency = true;

    const startMs = (4 * 60 * 60 + 13 * 60 + 11) * 1000;
    const key = 'innerday-sale-end-41311';
    let end = Number(sessionStorage.getItem(key));
    if (!end || end <= Date.now()) {
      end = Date.now() + startMs;
      sessionStorage.setItem(key, String(end));
    }

    const pad = (value) => String(value).padStart(2, '0');

    const paint = () => {
      let left = end - Date.now();
      if (left <= 0) {
        end = Date.now() + startMs;
        sessionStorage.setItem(key, String(end));
        left = startMs;
      }
      const total = Math.floor(left / 1000);
      const hours = Math.floor(total / 3600);
      const minutes = Math.floor((total % 3600) / 60);
      const seconds = total % 60;
      document.querySelectorAll('[data-urgency-h]').forEach((node) => {
        node.textContent = pad(hours);
      });
      document.querySelectorAll('[data-urgency-m]').forEach((node) => {
        node.textContent = pad(minutes);
      });
      document.querySelectorAll('[data-urgency-s]').forEach((node) => {
        node.textContent = pad(seconds);
      });
    };

    paint();
    window.setInterval(paint, 1000);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-videos"] && !Shopify.designMode) return;
  try {
    
  const bootTalkVideos = () => {
  document.querySelectorAll('.talk-videos').forEach((section) => {
    if (section.dataset.ready) return;
    section.dataset.ready = 'true';
    const track = section.querySelector('[data-talk-track]');
    const dots = section.querySelector('[data-talk-dots]');
    if (!track || !dots) return;
    const cards = [...track.children];

    const stops = () => {
      const width = cards[0] ? cards[0].getBoundingClientRect().width + 14 : track.clientWidth;
      const visible = Math.max(1, Math.floor((track.clientWidth + 8) / width));
      const count = Math.max(1, cards.length - visible + 1);
      return { width, count };
    };

    const paint = () => {
      const { width, count } = stops();
      const index = Math.min(count - 1, Math.max(0, Math.round(track.scrollLeft / width)));
      if (dots.childElementCount !== count) {
        dots.replaceChildren(...Array.from({ length: count }, (_, dot) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.setAttribute('aria-label', 'Videos ' + (dot + 1));
          button.addEventListener('click', () => {
            track.scrollTo({ left: dot * stops().width, behavior: 'smooth' });
          });
          return button;
        }));
      }
      [...dots.children].forEach((button, dot) => {
        if (dot === index) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
    };

    const move = (direction) => {
      const { width, count } = stops();
      const index = Math.min(count - 1, Math.max(0, Math.round(track.scrollLeft / width)));
      const next = Math.min(count - 1, Math.max(0, index + direction));
      track.scrollTo({ left: next * width, behavior: 'smooth' });
    };

    section.querySelector('[data-talk-prev]')?.addEventListener('click', () => move(-1));
    section.querySelector('[data-talk-next]')?.addEventListener('click', () => move(1));
    track.addEventListener('scroll', paint, { passive: true });
    // Videos download only once the row is close to the screen, never during first load.
    const loadVideo = (video) => {
      if (!video.dataset.src) return;
      video.preload = 'metadata';
      video.src = video.dataset.src;
      delete video.dataset.src;
    };
    if ('IntersectionObserver' in window) {
      const watcher = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        watcher.disconnect();
        section.querySelectorAll('video[data-src]').forEach(loadVideo);
      }, { rootMargin: '400px 0px' });
      watcher.observe(section);
    } else {
      window.addEventListener('load', () => section.querySelectorAll('video[data-src]').forEach(loadVideo), { once: true });
    }
    section.querySelectorAll('video').forEach((video) => {
      video.addEventListener('play', () => {
        section.querySelectorAll('video').forEach((other) => {
          if (other !== video) other.pause();
        });
      });
      video.addEventListener('loadedmetadata', () => {
        if (video.currentTime < 0.2 && video.duration > 1) {
          try { video.currentTime = 1; } catch (error) {}
        }
      });
    });
    paint();
  });
  };
  bootTalkVideos();
  document.addEventListener('shopify:section:load', bootTalkVideos);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  if (!window.__innerdayPdp) {
    window.__innerdayPdp = true;

    const hydratePhoto = (photo) => {
      if (!photo) return;
      if (photo.dataset.srcset) {
        photo.srcset = photo.dataset.srcset;
        delete photo.dataset.srcset;
      }
      if (photo.dataset.src) {
        photo.src = photo.dataset.src;
        delete photo.dataset.src;
      }
      photo.loading = 'eager';
    };

    const warmSlides = (slides, from) => {
      if (!window.__innerdayPdpWarm) return;
      [from, from - 1, from + 1, from + 2].forEach((i) => {
        hydratePhoto(slides[(i + slides.length) % slides.length]?.querySelector('img'));
      });
    };

    // Later slides stay empty until the first photo has painted, so they do not compete with it.
    const hydrateAllSlides = () => {
      window.__innerdayPdpWarm = true;
      document.querySelectorAll('[data-pdp-gallery] img[data-src], [data-pdp-gallery] img[data-srcset]').forEach(hydratePhoto);
    };
    const hydrateWhenIdle = () => {
      const run = () => setTimeout(() => (window.requestIdleCallback ? requestIdleCallback(hydrateAllSlides, { timeout: 2500 }) : hydrateAllSlides()), 800);
      if (document.readyState === 'complete') run();
      else window.addEventListener('load', run, { once: true });
    };
    hydrateWhenIdle();
    ['pointerdown', 'touchstart', 'keydown'].forEach((type) => {
      document.addEventListener(type, (event) => {
        if (event.target.closest?.('[data-pdp-gallery]')) hydrateAllSlides();
      }, { passive: true, once: true });
    });

    const markSlide = (gallery, index) => {
      const slides = [...gallery.querySelectorAll('[data-pdp-slide]')];
      const thumbs = [...gallery.querySelectorAll('[data-pdp-thumb]')];
      if (!slides.length) return 0;
      const next = (index + slides.length) % slides.length;
      warmSlides(slides, next);
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === next));
      thumbs.forEach((thumb, i) => {
        const on = i === next;
        thumb.classList.toggle('is-active', on);
        thumb.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      const strip = gallery.querySelector('.pdp__thumbs');
      const active = thumbs[next];
      if (strip && active) {
        const gap = parseFloat(getComputedStyle(strip).columnGap) || 0;
        const step = active.offsetWidth + gap;
        const max = Math.max(0, strip.scrollWidth - strip.clientWidth);
        const start = active.offsetLeft - strip.offsetLeft;
        let left = next === 0 ? 0 : next >= thumbs.length - 1 ? max : Math.min(max, Math.max(0, start - step));
        if (Math.abs(left - strip.scrollLeft) < 6 && max > 6) {
          left = strip.scrollLeft < max - 6
            ? Math.min(max, strip.scrollLeft + step * 0.75)
            : Math.max(0, strip.scrollLeft - step * 0.75);
        }
        strip.scrollTo({ left, behavior: 'smooth' });
      }
      return next;
    };

    const showSlide = (gallery, index) => {
      const stage = gallery.querySelector('.pdp__stage');
      const slides = [...gallery.querySelectorAll('[data-pdp-slide]')];
      if (!stage || !slides.length) return;
      const next = markSlide(gallery, index);
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      stage.scrollTo({ left: slides[next].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    };

    document.querySelectorAll('[data-pdp-gallery]').forEach((gallery) => {
      const stage = gallery.querySelector('.pdp__stage');
      if (!stage) return;
      const slides = [...gallery.querySelectorAll('[data-pdp-slide]')];
      if (slides.length < 2) return;

      const warmFirst = () => setTimeout(() => warmSlides(slides, 0), 600);
      if (document.readyState === 'complete') warmFirst();
      else window.addEventListener('load', warmFirst, { once: true });

      stage.addEventListener('scroll', () => {
        const mid = stage.scrollLeft + stage.clientWidth / 2;
        let index = 0;
        slides.forEach((slide, i) => {
          if (slide.offsetLeft <= mid) index = i;
        });
        const current = slides.findIndex((slide) => slide.classList.contains('is-active'));
        if (index !== current) markSlide(gallery, index);
      }, { passive: true });
    });

    const syncBar = (root) => {
      const bar = root.querySelector('[data-pdp-bar]');
      const offers = root.querySelector('[data-pdp-offers]');
      if (!bar || !offers) return;
      const plan = offers.dataset.plan === 'once' ? 'once' : 'sub';
      const checked = root.querySelector('[data-pdp-offer]:checked');
      const choice = bar.querySelector('[data-pdp-bar-choice]');
      const serving = bar.querySelector('[data-pdp-bar-serving]');
      const shot = bar.querySelector('[data-pdp-bar-shot]');
      const submit = root.querySelector('.pdp__submit');
      const add = bar.querySelector('[data-pdp-bar-add]');
      const addLong = bar.querySelector('[data-pdp-bar-add-long]');
      const addShort = bar.querySelector('.pdp-bar__add-short');
      if (checked) {
        if (choice) choice.textContent = checked.dataset[plan === 'once' ? 'labelOnce' : 'labelSub'] || '';
        if (serving) serving.textContent = checked.dataset[plan === 'once' ? 'servingOnce' : 'servingSub'] || '';
        if (shot && checked.dataset.image) shot.src = checked.dataset.image;
      }
      bar.querySelectorAll('[data-pdp-bar-option]').forEach((option) => {
        const on = checked && option.dataset.variantId === checked.dataset.variantId;
        option.classList.toggle('is-selected', on);
        option.setAttribute('aria-selected', on ? 'true' : 'false');
        const label = option.querySelector('.pdp-bar__option-label');
        const line = option.querySelector('.pdp-bar__option-serving');
        const source = root.querySelector(`[data-pdp-offer][data-variant-id="${option.dataset.variantId}"]`);
        if (source && label) label.textContent = source.dataset[plan === 'once' ? 'labelOnce' : 'labelSub'] || '';
        if (source && line) line.textContent = source.dataset[plan === 'once' ? 'servingOnce' : 'servingSub'] || '';
      });
      if (submit && add && addLong) {
        add.disabled = submit.disabled;
        const label = submit.querySelector('.button__label');
        addLong.textContent = label ? label.textContent : 'Add to cart';
        if (addShort) addShort.textContent = submit.disabled ? 'Sold out' : 'Add';
      }
    };

    const closeBarMenu = (bar) => {
      if (!bar) return;
      bar.querySelector('[data-pdp-bar-menu]')?.classList.remove('is-open');
      const toggle = bar.querySelector('[data-pdp-bar-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    };

    const syncOffer = (root) => {
      const offers = root.querySelector('[data-pdp-offers]');
      if (!offers) return;
      const plan = offers.dataset.plan === 'once' ? 'once' : 'subscribe';
      const checked = root.querySelector('[data-pdp-offer]:checked');
      offers.querySelectorAll('.pdp__jar').forEach((card) => {
        card.classList.toggle('is-selected', card.contains(checked));
      });
      offers.querySelectorAll('[data-pdp-plan-choice]').forEach((card) => {
        const on = card.dataset.pdpPlanChoice === plan;
        card.classList.toggle('is-selected', on);
        card.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (!checked) return;
      const write = (selector, value) => {
        const node = offers.querySelector(selector);
        if (node && value != null) node.textContent = value;
      };
      write('[data-pdp-save]', 'Save ' + checked.dataset.subOff + '%');
      write('[data-pdp-every]', checked.dataset.every);
      write('[data-pdp-renew]', checked.dataset.renew);
      write('[data-pdp-sub-pack]', checked.dataset.subPrice);
      write('[data-pdp-retail]', checked.dataset.retail);
      write('[data-pdp-once-pack]', checked.dataset.oncePrice);
      write('[data-pdp-once-jars]', (checked.dataset.pack || 'This pack') + ', shipped once');
      write('[data-pdp-vs]', checked.dataset.vs);
      write('[data-pdp-serving-sub]', checked.dataset.servingSub);
      write('[data-pdp-serving-once]', checked.dataset.servingOnce);
      offers.querySelector('[data-pdp-gift]')?.classList.toggle('is-off', checked.dataset.freeJar !== 'true');
      const onceWas = offers.querySelector('[data-pdp-once-was]');
      if (onceWas) onceWas.hidden = Number(checked.dataset.onceOff) === 0;
      const submitNow = root.querySelector('[data-pdp-submit-now]');
      const submitWas = root.querySelector('[data-pdp-submit-was]');
      if (submitNow) submitNow.textContent = (plan === 'once' ? checked.dataset.oncePrice : checked.dataset.subPrice) || '';
      if (submitWas) {
        submitWas.textContent = checked.dataset.retail || '';
        submitWas.hidden = plan === 'once' && Number(checked.dataset.onceOff) === 0;
      }
    };

    const paintDealPrice = (node, now, was) => {
      if (!node) return;
      node.replaceChildren();
      if (now) {
        const price = document.createElement('span');
        price.textContent = now;
        node.appendChild(price);
      }
      if (was && was !== now) {
        const strike = document.createElement('s');
        strike.textContent = was;
        node.appendChild(strike);
      }
    };

    const syncDeals = (root) => {
      const deals = root.querySelector('[data-pdp-deals]');
      if (!deals) return;
      const refill = deals.querySelector('[data-pdp-refill]');
      const on = !refill || refill.checked;
      deals.dataset.refill = on ? 'on' : 'off';
      const checked = deals.querySelector('[data-pdp-deal]:checked');
      const gifts = checked?.value === '3' ? '2' : checked?.value === '2' ? '1' : '0';
      deals.dataset.gifts = gifts;
      deals.querySelectorAll('.pdp-deal').forEach((card) => {
        card.classList.toggle('is-selected', card.contains(checked));
        const deal = card.querySelector('[data-pdp-deal]');
        const value = card.querySelector('.pdp-deal__value');
        const was = (on ? deal?.dataset.wasRefill : deal?.dataset.wasOnce) || '';
        const now = (on ? deal?.dataset.priceRefill : deal?.dataset.priceOnce) || '';
        if (value) value.hidden = !was || was === now;
      });
      const idInput = root.querySelector('[data-pdp-deal-id]');
      if (idInput && checked?.dataset.variantId) idInput.value = checked.dataset.variantId;
      const planInput = root.querySelector('[data-pdp-selling-plan]');
      if (planInput) {
        const planId = on ? checked?.dataset.planId : '';
        planInput.value = planId || '';
        planInput.disabled = !planId;
      }
      const saleNow = (on ? checked?.dataset.priceRefill : checked?.dataset.priceOnce) || '';
      const saleWas = (on ? checked?.dataset.wasRefill : checked?.dataset.wasOnce) || '';
      const saleSave = (on ? checked?.dataset.saveRefill : checked?.dataset.saveOnce) || '';
      const promoNow = deals.querySelector('[data-pdp-sale-now]');
      const promoWas = deals.querySelector('[data-pdp-sale-was]');
      const promoBadge = deals.querySelector('[data-pdp-sale-badge]');
      if (promoNow) promoNow.textContent = saleNow;
      if (promoWas) {
        promoWas.textContent = saleWas;
        promoWas.hidden = !saleWas || saleWas === saleNow;
      }
      if (promoBadge) {
        let salePrefix = 'BIGGEST SALE OF THE YEAR - SAVE ';
        if (checked && deals.hasAttribute('data-sale-prefix-1')) {
          const radios = [...deals.querySelectorAll('[data-pdp-deal]')];
          const idx = radios.indexOf(checked) + 1;
          salePrefix = deals.getAttribute('data-sale-prefix-' + idx) || salePrefix;
        }
        promoBadge.textContent = saleSave ? salePrefix + saleSave : '';
        promoBadge.hidden = !saleSave;
      }
      root.querySelectorAll('[data-pdp-deal-price]').forEach((node) => {
        node.textContent = (on ? checked?.dataset.priceRefill : checked?.dataset.priceOnce) || '';
      });
      root.querySelectorAll('[data-pdp-deal-was]').forEach((node) => {
        const was = (on ? checked?.dataset.wasRefill : checked?.dataset.wasOnce) || '';
        const now = (on ? checked?.dataset.priceRefill : checked?.dataset.priceOnce) || '';
        node.textContent = was;
        node.hidden = !was || was === now;
      });
      const choice = root.querySelector('[data-pdp-bar-choice]');
      const serving = root.querySelector('[data-pdp-bar-serving]');
      const shot = root.querySelector('[data-pdp-bar-shot]');
      if (checked && choice) choice.textContent = checked.dataset.choice || '';
      if (serving) paintDealPrice(serving, on ? checked?.dataset.priceRefill : checked?.dataset.priceOnce, on ? checked?.dataset.wasRefill : checked?.dataset.wasOnce);
      if (shot && checked?.dataset.image) shot.src = checked.dataset.image;
      root.querySelectorAll('[data-pdp-bar-option][data-deal]').forEach((option) => {
        const source = root.querySelector(`[data-pdp-deal][value="${option.dataset.deal}"]`);
        const line = option.querySelector('.pdp-bar__option-serving');
        if (source && line) paintDealPrice(line, on ? source.dataset.priceRefill : source.dataset.priceOnce, on ? source.dataset.wasRefill : source.dataset.wasOnce);
        const selected = source === checked;
        option.classList.toggle('is-selected', selected);
        option.setAttribute('aria-selected', selected ? 'true' : 'false');
      });
    };

    const buildDealBar = (root) => {
      const menu = root.querySelector('[data-pdp-bar-menu]');
      const deals = root.querySelector('[data-pdp-deals]');
      if (!menu || !deals || menu.childElementCount) return;
      deals.querySelectorAll('[data-pdp-deal]').forEach((deal) => {
        const option = document.createElement('button');
        option.type = 'button';
        option.className = 'pdp-bar__option';
        option.setAttribute('role', 'option');
        option.dataset.pdpBarOption = '';
        option.dataset.deal = deal.value;
        option.innerHTML = '<span class="pdp-bar__option-label"></span><span class="pdp-bar__option-serving"></span>';
        const label = option.querySelector('.pdp-bar__option-label');
        if (label) label.textContent = deal.dataset.choice || '';
        menu.appendChild(option);
      });
    };

    const buildBar = (root) => {
      const menu = root.querySelector('[data-pdp-bar-menu]');
      if (!menu || menu.childElementCount) return;
      root.querySelectorAll('[data-pdp-offer]').forEach((offer) => {
        const option = document.createElement('button');
        option.type = 'button';
        option.className = 'pdp-bar__option';
        option.setAttribute('role', 'option');
        option.dataset.pdpBarOption = '';
        option.dataset.variantId = offer.dataset.variantId;
        option.innerHTML = '<span class="pdp-bar__option-label"></span><span class="pdp-bar__option-serving"></span>';
        menu.appendChild(option);
      });
      syncBar(root);
    };

    document.querySelectorAll('[data-pdp]').forEach((root) => {
      syncOffer(root);
      const offers = root.querySelector('[data-pdp-offers]');
      const deals = root.querySelector('[data-pdp-deals]');
      const bar = root.querySelector('[data-pdp-bar]');
      const sentinel = deals || offers;
      if (!sentinel || !bar) return;
      if (deals) {
        buildDealBar(root);
        syncDeals(root);
      } else {
        buildBar(root);
      }
      const placeBar = () => {
        const passed = sentinel.getBoundingClientRect().bottom < 72;
        bar.classList.toggle('is-on', passed);
        if (!passed) closeBarMenu(bar);
      };
      placeBar();
      window.addEventListener('scroll', placeBar, { passive: true });
      window.addEventListener('resize', placeBar);
    });

    document.addEventListener('click', (event) => {
      const spec = event.target.closest('[data-pdp-spec]');
      if (spec) {
        const item = spec.closest('.pdp-spec');
        const panel = item?.querySelector('[data-pdp-spec-panel]');
        const open = spec.getAttribute('aria-expanded') === 'true';
        spec.setAttribute('aria-expanded', open ? 'false' : 'true');
        item?.classList.toggle('is-open', !open);
        if (panel) panel.inert = open;
        return;
      }

      const clip = event.target.closest('[data-pdp-clip]');
      if (clip) {
        const card = clip.closest('.pdp-clip');
        const video = card?.querySelector('video');
        if (!card || !video) return;
        document.querySelectorAll('.pdp-clip.is-playing video').forEach((other) => {
          if (other === video) return;
          other.pause();
          other.closest('.pdp-clip')?.classList.remove('is-playing');
        });
        card.classList.add('is-playing');
        video.controls = true;
        video.play();
        return;
      }

      const thumb = event.target.closest('[data-pdp-thumb]');
      if (thumb) {
        const gallery = thumb.closest('[data-pdp-gallery]');
        if (gallery) showSlide(gallery, Number(thumb.dataset.pdpThumb));
        return;
      }

      const nav = event.target.closest('[data-pdp-nav]');
      if (nav) {
        const gallery = nav.closest('[data-pdp-gallery]');
        if (!gallery) return;
        const slides = [...gallery.querySelectorAll('[data-pdp-slide]')];
        const current = slides.findIndex((slide) => slide.classList.contains('is-active'));
        const delta = nav.dataset.pdpNav === 'next' ? 1 : -1;
        showSlide(gallery, current + delta);
        return;
      }

      const plan = event.target.closest('[data-pdp-plan-choice]');
      if (plan) {
        const offers = plan.closest('[data-pdp-offers]');
        const root = plan.closest('[data-pdp]');
        if (!offers || !root) return;
        const next = plan.dataset.pdpPlanChoice === 'once' ? 'once' : 'subscribe';
        offers.dataset.plan = next;
        const submit = root.querySelector('.pdp__submit');
        const label = submit?.querySelector('.button__label');
        if (submit && label && !submit.disabled) {
          label.textContent = next === 'subscribe' ? submit.dataset.labelSub : submit.dataset.labelOnce;
        }
        syncOffer(root);
        syncBar(root);
        return;
      }

      const barToggle = event.target.closest('[data-pdp-bar-toggle]');
      if (barToggle) {
        const bar = barToggle.closest('[data-pdp-bar]');
        const menu = bar?.querySelector('[data-pdp-bar-menu]');
        if (!menu) return;
        const open = !menu.classList.contains('is-open');
        menu.classList.toggle('is-open', open);
        barToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        return;
      }

      const dealOption = event.target.closest('[data-pdp-bar-option][data-deal]');
      if (dealOption) {
        const root = dealOption.closest('[data-pdp]');
        const deal = root?.querySelector(`[data-pdp-deal][value="${dealOption.dataset.deal}"]`);
        if (deal) {
          deal.checked = true;
          syncDeals(root);
        }
        closeBarMenu(dealOption.closest('[data-pdp-bar]'));
        return;
      }

      const barOption = event.target.closest('[data-pdp-bar-option]');
      if (barOption) {
        const root = barOption.closest('[data-pdp]');
        const offer = root?.querySelector(`[data-pdp-offer][data-variant-id="${barOption.dataset.variantId}"]`);
        if (offer) {
          offer.checked = true;
          offer.dispatchEvent(new Event('change', { bubbles: true }));
        }
        closeBarMenu(barOption.closest('[data-pdp-bar]'));
        return;
      }

      const barAdd = event.target.closest('[data-pdp-bar-add]');
      if (barAdd) {
        const root = barAdd.closest('[data-pdp]');
        const submit = root?.querySelector('.pdp__submit');
        if (submit && !submit.disabled) submit.click();
        return;
      }

      if (!event.target.closest('[data-pdp-bar]')) {
        document.querySelectorAll('[data-pdp-bar]').forEach(closeBarMenu);
      }

      const qty = event.target.closest('[data-pdp-qty]');
      if (!qty) return;
      const input = qty.parentElement.querySelector('input[name="quantity"]');
      if (!input) return;
      const delta = qty.dataset.pdpQty === 'up' ? 1 : -1;
      input.value = String(Math.max(1, (parseInt(input.value, 10) || 1) + delta));
    });

    document.addEventListener('change', (event) => {
      const dealControl = event.target.closest('[data-pdp-refill], [data-pdp-deal]');
      if (dealControl) {
        const root = dealControl.closest('[data-pdp]');
        if (root) syncDeals(root);
        return;
      }

      const offer = event.target.closest('[data-pdp-offer]');
      if (!offer) return;
      const root = offer.closest('[data-pdp]');
      if (!root) return;
      const idInput = root.querySelector('[data-pdp-id]');
      if (idInput && offer.dataset.variantId) idInput.value = offer.dataset.variantId;
      syncOffer(root);
      syncBar(root);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') document.querySelectorAll('[data-pdp-bar]').forEach(closeBarMenu);
    });
  }

  const paintShip = () => {
    const now = new Date();
    const ship = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    if (now.getHours() >= 17) ship.setDate(ship.getDate() + 1);
    const label = ship.toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric' });
    document.querySelectorAll('[data-pdp-ship-date]').forEach((el) => {
      el.textContent = label;
    });
  };
  paintShip();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-wall"] && !Shopify.designMode) return;
  try {
    
  if (!window.__innerdayWall) {
    window.__innerdayWall = true;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const reveal = (cards) => {
      cards.forEach((card, index) => {
        window.setTimeout(() => card.classList.add('is-in'), reduce ? 0 : index * 110);
      });
    };

    const scan = () => {
      const waiting = [...document.querySelectorAll('[data-wall-card]:not(.is-in)')];
      if (!waiting.length) return;
      if (reduce) {
        reveal(waiting);
        return;
      }
      const line = window.innerHeight * 0.92;
      const visible = waiting.filter((card) => card.getBoundingClientRect().top < line);
      visible.sort((a, b) => {
        const ar = a.getBoundingClientRect();
        const br = b.getBoundingClientRect();
        return ar.top - br.top || ar.left - br.left;
      });
      reveal(visible);
    };

    let ticking = false;
    const queue = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        ticking = false;
        scan();
      });
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
    else scan();
    window.addEventListener('scroll', queue, { passive: true });
    document.addEventListener('shopify:section:load', scan);

    document.addEventListener('click', (event) => {
      const play = event.target.closest('[data-wall-play]');
      if (!play) return;
      const frame = play.closest('[data-wall-frame]');
      if (!frame) return;
      const video = frame.querySelector('video');
      if (video) {
        video.controls = true;
        video.play();
        frame.classList.add('is-playing');
        return;
      }
      const embed = frame.querySelector('[data-wall-embed]');
      if (!embed || embed.dataset.loaded === 'true') return;
      embed.dataset.loaded = 'true';
      const iframe = document.createElement('iframe');
      iframe.src = embed.dataset.src;
      iframe.title = embed.dataset.title || 'Video';
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
      iframe.allowFullscreen = true;
      embed.appendChild(iframe);
      frame.classList.add('is-playing');
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  if (!window.__innerdayReviews) {
    window.__innerdayReviews = true;

    document.addEventListener('click', (event) => {
      const read = event.target.closest('[data-review-more]');
      if (read) {
        const card = read.closest('[data-review-card]');
        if (!card) return;
        const open = card.classList.toggle('is-open');
        read.textContent = open ? 'Show less' : 'Read more';
        return;
      }

      const pageButton = event.target.closest('[data-reviews-page]');
      if (pageButton) {
        const section = pageButton.closest('.reviews');
        const size = Number(section?.dataset.pageSize || 0);
        const page = Number(pageButton.dataset.reviewsPage);
        if (!section || !size || !page) return;
        [...section.querySelectorAll('[data-review-card]')].forEach((card, index) => {
          const cardPage = Math.floor(index / size) + 1;
          card.hidden = cardPage !== page;
        });
        section.querySelectorAll('[data-reviews-page]').forEach((button) => {
          if (Number(button.dataset.reviewsPage) === page) button.setAttribute('aria-current', 'page');
          else button.removeAttribute('aria-current');
        });
        return;
      }

      const more = event.target.closest('[data-reviews-more]');
      if (!more) return;
      const grid = more.parentElement.querySelector('[data-reviews-grid]');
      if (!grid) return;
      [...grid.querySelectorAll('[data-review-card].is-hidden')].slice(0, 4).forEach((card) => {
        card.classList.remove('is-hidden');
      });
      if (!grid.querySelector('[data-review-card].is-hidden')) more.hidden = true;
    });
  }

  } catch(e) { console.error(e); }
})();
})();
